import getErrorsListFromError from "./getErrorsListFromError";
export default function getValidationErrorMessages(e) {
    var errors = getErrorsListFromError(e);
    return Object.values(errors)
        .map(function (v) { return v.join(', '); });
}
//# sourceMappingURL=getValidationErrorMessages.js.map